import { BaseOapStatus } from '@/classes/SubmissionStatuses/BaseOapStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'

export class PaymentErrorStatus extends BaseOapStatus {
	getStatusText() {
		return 'Payment Error'
	}

	getToolTipText() {
		return {
			title: this.submissionStatus.provider + ' ' + this.getStatusText(),
			body: `The payment for this ${this.submissionStatus.provider} submission has failed. Please contact salesstudio@precoa.com.`,
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
